import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';
import TYPES from '@/types';
import UpdatePersonRepository from '../../../domain/repositories/update-person-repository';
import { UpdatePersonDto } from '../../../domain/dtos/update-person-dto';

@Injectable()
export default class UpdatePersonHttpRepository implements UpdatePersonRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly path = `${process.env.VUE_APP_API_URL}/api/v1/app/on-boarding/person/{ID}/`;

  update(person: UpdatePersonDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.path.replace('{ID}', person.id), 'PATCH', {
        rfc: person.rfc,
      })
        .then((response) => {
          if (response.ok) {
            resolve();
          } else {
            response.json()
              .then(({ message }) => {
                reject(new Error(message));
              });
          }
        })
        .catch(reject);
    });
  }
}
